import { render, staticRenderFns } from "./AccountStatement.vue?vue&type=template&id=b759522e"
import script from "./AccountStatement.vue?vue&type=script&lang=js"
export * from "./AccountStatement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports